import { useFlag, useVariant } from '@calendly/feature-check-react'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { isOnFreeStageSelector } from 'features/billing'
import { useTrack, TRACKING_EVENT_NAMES } from 'hooks/analytics_events'

export const useNotetakerFiveFreeRecapsExperiment = (shouldCheck = true) => {
  const isOnFreeStage = useSelector(isOnFreeStageSelector)
  const hasMeetingIntelligenceFlag = useFlag('meeting_intelligence')
  const shouldTrackExperiment = shouldCheck && isOnFreeStage && hasMeetingIntelligenceFlag
  const variant = useVariant('growth_notetaker_five_free_recaps', shouldTrackExperiment)
  const isInExperiment = variant === 'variant'
  const track = useTrack()

  useEffect(() => {
    if (shouldTrackExperiment && variant) {
      track({
        name: TRACKING_EVENT_NAMES.FEATURE_FLAG_ENCOUNTERED,
        properties: {
          flag_key: 'growth_notetaker_five_free_recaps',
          variation_key: variant,
          rule: 'ab_test',
          source: 'frontend'
        }
      })
    }
  }, [shouldTrackExperiment, variant, track])

  if (!shouldTrackExperiment) {
    return { isInExperiment: false }
  }

  return { isInExperiment }
}
